import React from "react";
import BoardingPassImg from "src/assets/boardingPass.png";
import InstagramIcon from "src/assets/instagram.png";
import Header from "src/components/Header";
import SuccessParticles from "src/components/SuccessParticles";
import Footer from "src/components/Footer";

function Confirm() {
  return (
    <div className="relative z-10 h-full w-full flex flex-col items-center justify-start mx-[16px]">
      <div className="w-full items-center justify-center flex px-2 md:px-[15%]">
        <Header isUserLoggedIn={true} onPress={() => {}} />
      </div>

      <div
        className="relative z-20 flex flex-col h-full w-full items-center justify-start pt-20"
        id="confirmation-success-message"
      >
        <h2 className="flex flex-col-reverse sm:flex-row leading-none sm:gap-4 mb-2 items-center text-6xl successful_subscribe_particles">
          <span className="text-white">You are in!</span>
          <span className="block relative w-24 h-24 flex-shrink-0">
            <img
              id="boarding-pass-image"
              src={BoardingPassImg}
              className="object-cover"
              alt="explore the globe"
              sizes="10vw"
            />
          </span>
        </h2>
        <p className="text-xl text-center mt-3 text-white" id="confirmation-subtext">
          We&apos;ll email your invite as soon as its ready.
        </p>

        <a
          id="instagram-logo"
          href="https://instagram.com/sparetime.travel/"
          target="_blank"
          rel="noopener noreferrer"
          aria-label="Visit our Instagram"
          className="mt-20"
        >
          <img
            src={InstagramIcon}
            alt="Instagram"
            className="h-8 w-8 mx-auto"
          />
        </a>
      </div>

      {/* Position particles behind text, disable pointer events */}
      <div className="absolute inset-0 z-10 pointer-events-none">
        <SuccessParticles />
      </div>

      <Footer />
    </div>
  );
}

export default Confirm;
